import $ from 'jquery';

$('.tabs__navigation-item').on('click', function () {
    let $wrapper = $(this).closest('.tabs');
    let index = $(this).data('index');
    $wrapper.find('.tabs__navigation-item').removeClass('tabs__navigation-item--active');
    $wrapper.find('.tabs__content').removeClass('tabs__content--active');
    $wrapper.find('.tabs__navigation-item[data-index="'+ index +'"]').addClass('tabs__navigation-item--active');
    $wrapper.find('.tabs__content[data-index="'+ index +'"]').addClass('tabs__content--active');
})
